<template>
    <div class="app-container">
    <el-dialog title="分店信息"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" ref="formparams" label-width="100px">
           <el-form-item label="分店名称">
            <el-input v-model="formparams.name" placeholder="请输入分店名称"></el-input>
          </el-form-item>
          <el-form-item label="分店地址">
            <el-input v-model="formparams.address" placeholder="请输入分店详细地址"></el-input>
          </el-form-item>
          <el-form-item label="地铁导航" v-show="false">
            <el-input v-model="formparams.metroroute" placeholder="请输入地铁导航"></el-input>
          </el-form-item>
           <el-form-item label="公交导航" v-show="false">
            <el-input v-model="formparams.transitlot" placeholder="请输入公交导航"></el-input>
          </el-form-item>
          <el-form-item label="停车场数量" v-show="false">
            <el-input v-model="formparams.parkinglotdetails" placeholder="请输入停车场数量信息"></el-input>
          </el-form-item>
          <el-form-item label="停车场收费信息" v-show="false">
            <el-input v-model="formparams.parkinglotcharge" placeholder="请输入停车场收费信息"></el-input>
          </el-form-item>
          <el-form-item label="周围环境信息" v-show="false">
            <el-input v-model="formparams.groundfacilities" placeholder="请输入周围环境信息" ></el-input>
          </el-form-item>
          <el-form-item label="场地照明信息" v-show="false">
            <el-input v-model="formparams.lightingfacilities" placeholder="请输入场地照明信息" ></el-input>
          </el-form-item>

          <el-form-item label="场地配置信息" v-show="false">
            <el-input v-model="formparams.restfacilities" placeholder="请输入场地配置信息" ></el-input>
          </el-form-item>
          <el-form-item label="分店说明">
            <!-- <el-input v-model="formparams.venuedetails" placeholder="请输入分店说明" maxlength="50"></el-input> -->
            <editor-bar v-model="formparams.venuedetails" :isClear="isClear"></editor-bar>
          </el-form-item>
          <el-form-item label="客服电话">
            <el-input v-model="formparams.phone" placeholder="请输入客服电话" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="分店图片" required ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            *提示*：为了更好的用户体验，图片请提供320*160像素，文件大小不超过500kb。
        </el-form-item>
        <el-form-item label="上/下线">
          <el-switch
            v-model="formparams.isWeb"
            active-value= '1'
            inactive-value= '0'
            active-text="上线"
            inactive-text="下线">
          </el-switch>
        </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="82vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="name" label="分店名称"></el-table-column>
        <el-table-column  prop="imgaddress" label="分店地址"></el-table-column>
        <el-table-column  width="150" prop="imgphone" label="分店电话"></el-table-column>
        <el-table-column label="分店图片">
          <template slot-scope="scope">
            <img class="imgList" style="width:200px;height:100px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.shopImg" alt="">
          </template>
        </el-table-column>
        <el-table-column label="上线状态" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isWeb==1">上线</div>
            <div v-if="scope.row.isWeb==0">下线</div>
          </template>
        </el-table-column>
        <el-table-column label="分店说明">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="300px">
              <p style="width:300px;" v-html="scope.row.venuedetails"></p>
              <div slot="reference" class="name-wrapper" >
                <el-tag size="medium">分店说明</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
let that;
import {getShops } from "../../api/configApi";
// import mainHead from "../../components/mainHead/mainHead";
import EditorBar from '../../components/wangEnduit'
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      hideUpload:false,
      isClear: false,
      detail:'',
      rules:{
        address:[{ required:true,message:'请输入分店地址信息',trigger:'blur' }],
        phone:[{ required:true,message:'请输入客服电话',trigger:'blur' }],
      },
      oldData:{},
      formparams:{
        name:'',
        address:'',
        metroroute:'',
        transitlot:'',
        parkinglotdetails:'',
        parkinglotcharge:'',
        groundfacilities:'',
        lightingfacilities:'',
        restfacilities:'',
        venuedetails:'',
        phone:'',
        shopNum:'',
        isWeb:''
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      shopList:[],
      newData:{}
    }
  },
  components: {
    EditorBar
  },
  beforeCreate(){
  },
  created(){
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    //查询分店类型
    getTableList(){
      getShops().then((res)=>{
        this.loading = false
        if(res.msg=='success'){
          this.tableData = res.data
          this.shopList = []
          sessionStorage.setItem('shopListAll',JSON.stringify(res.data))
          for(var i=0;i<res.data.length;i++){
              if(res.data[i].isWeb == 1){
                this.shopList.push(res.data[i])
              }
          }
          sessionStorage.setItem('shopList',JSON.stringify(this.shopList))
          // for(var item of res.data){
          //   console.log(item.isWeb)
          //   if(item.isWeb==1){
          //     this.shopList.push(item)
          //     sessionStorage.setItem('shopList',this.shopList)
          //   }
            // item.isWeb == 1
          // }
        }else{
          this.$message.error(res.data)
        }
        
      })
    },
    //编辑
    edit(row){
      this.newData = row
      this.dialogVisible = true
      this.formparams.name = row.name
      this.formparams.address = row.imgaddress
      this.formparams.groundfacilities = row.imggroundfacilities
      this.formparams.metroroute = row.imgmetroroute
      this.formparams.transitlot = row.imgtransitlot
      this.formparams.parkinglotdetails = row.imgparkinglotdetails

      this.formparams.parkinglotcharge = row.imgparkinglotcharge
      this.formparams.lightingfacilities = row.imglightingfacilities
      this.formparams.restfacilities = row.imgrestfacilities
      this.formparams.venuedetails = row.venuedetails
      this.formparams.phone = row.imgphone
      this.formparams.shopNum = row.shopNum
      this.formparams.isWeb= row.isWeb.toString()
      this.fileList=[]
      if(this.fileList){
        this.hideUpload = true
      } else {
        this.hideUpload = false
      }
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.shopImg})
    },
    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length <= this.fileList.length;
    },
    uploadFile(file){
        this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('上传logo不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
            this.$message.error('上传图片大小不能超过500kb');
            this.fileList= []
            this.hideUpload = false
            return
          }
            
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数字字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
        if (valid) {
            this.formData = new FormData()
            this.$refs.upload.submit();
            this.formData.append('shopNum', this.formparams.shopNum);
            if(this.formparams.name!='' && this.newData.name != this.formparams.name){
              this.formData.append('name', this.formparams.name);
            }
            if(this.formparams.address!='' && this.newData.imgaddress != this.formparams.address){
              this.formData.append('address', this.formparams.address);
            }
            if(this.formparams.metroroute!=''&& this.newData.imgmetroroute != this.formparams.metroroute){
              this.formData.append('metroroute', this.formparams.metroroute);
            }
            if(this.formparams.transitlot!=''&& this.newData.imgtransitlot != this.formparams.transitlot){
              this.formData.append('transitlot', this.formparams.transitlot);
            }
            if(this.formparams.parkinglotdetails!=''&& this.newData.imgparkinglotdetails != this.formparams.parkinglotdetails){
              this.formData.append('parkinglotdetails', this.formparams.parkinglotdetails);
            }
            if(this.formparams.parkinglotcharge!=''&& this.newData.imgparkinglotcharge != this.formparams.parkinglotcharge){
              this.formData.append('parkinglotcharge', this.formparams.parkinglotcharge);
            }
            if(this.formparams.groundfacilities!=''&& this.newData.imggroundfacilities != this.formparams.groundfacilities){
              this.formData.append('groundfacilities', this.formparams.groundfacilities);
            }
            if(this.formparams.lightingfacilities!=''&& this.newData.imglightingfacilities != this.formparams.lightingfacilities){
              this.formData.append('lightingfacilities', this.formparams.lightingfacilities);
            }
            if(this.formparams.restfacilities!=''&& this.newData.imglightingfacilities != this.formparams.lightingfacilities){
              this.formData.append('restfacilities', this.formparams.restfacilities);
            }
            if(this.formparams.venuedetails!=''&& this.newData.venuedetails != this.formparams.venuedetails){
              this.formData.append('venuedetails', this.formparams.venuedetails);
            }
            if(this.formparams.phone!=''&& this.newData.imgphone != this.formparams.phone){
              this.formData.append('phone', this.formparams.phone);
            }

            // if(this.newData.isWeb.toString() != this.formparams.isWeb){
              this.formData.append('isWeb', this.formparams.isWeb); 
            // }
            let config = {
                headers: {
                  'Content-Type':'multipart/form-data',
                  'token':sessionStorage.getItem('token')
                }
            }
            this.$http.post('venue/updateShopsInfo', this.formData, config).then((res)=>{
              console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              }
              this.getTableList()
            })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    }
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// shopList.vue?223581a4